import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.SendConsent.IRequest;
type Response = Api.Core.Contract.SendConsent.IResponse;
type Headers = Api.Core.Contract.SendConsent.IHeaders;
const url = '/api/Sales/Contract/SendConsent/:contractId/:consentRequestType';
export default async function contractSendConsentApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
